import useFormContext, { FormContext } from 'common/useFormContext';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Form } from 'react-bootstrap';

interface FormValidationProps {
    children: React.ReactNode;
}

export interface FormValidationRefProps {
    validate(): boolean;
    reset(): void;
}

export type FormValidationHook = React.MutableRefObject<FormValidationRefProps>;

export function useFormValidation(): FormValidationHook {
    return useRef<FormValidationRefProps>(null);
}

const FormValidation = forwardRef<FormValidationRefProps, FormValidationProps>((props, ref) => {

    const formRef = useRef<HTMLFormElement>();
    const formContext = useFormContext(formRef);

    useImperativeHandle(ref, () => {
        return {
            validate: () => formContext.validate(),
            reset: () => formContext.reset(),
        }
    });

    return <FormContext.Provider value={formContext}>
        <Form noValidate ref={formRef} validated={formContext.isValidated}>
            {props.children}
        </Form>
    </FormContext.Provider>;
});

export default FormValidation;